<template>
  <div class="asc-doc-mgmt-help-about-grid--wrapper">
    <asc-selection-grid
      class="asc-doc-mgmt-help-about-grid"
      row-selection="multiple"
      :grid-size="400"
      :values="values"
      :full-columns="true"
      :column-defs="columnDefs"
      :deselect-all="deselectAllUserGuides"
      :disabled="gridDisabled"
      @onSelectionChanged="handleSelectionChanged"
      @onSelectionGridReady="handleSelectionGridReady"
    />
  </div>
</template>

<script>
import AscSelectionGrid from '@/components/molecules/AscSelectionGrid'
import { getFormattedAPIDate } from '@/utilities/dates'
import {
  exactEqualStringMatcher,
  dateStringMatcher,
} from '@/components/agGrid/AgGridHelperMethods'
import {
  AscAgGridDateFloatFilter,
  AscLinkCellRenderer,
} from '@/components/agGrid'

export default {
  name: 'AscDocMgmtHelpAboutGridWrapper',

  components: {
    AscSelectionGrid,
    AscLinkCellRenderer,
    AscAgGridDateFloatFilter,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    deselectAllUserGuides: {
      type: Boolean,
      default: false,
    },
    uploadNewDocAvailable: {
      type: Boolean,
      default: false,
    },
    uploadNewDocDisabled: {
      type: Boolean,
      default: false,
    },
    gridDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      columnDefs: [
        {
          resizable: false,
          width: 42,
          maxWidth: 42,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          suppressMovable: true,
          suppressSizeToFit: true,
          field: '',
        },
        {
          headerName: 'document',
          field: 'filename',
          width: 218,
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: exactEqualStringMatcher,
          },
          cellClass: 'document',
          cellRenderer: 'AscLinkCellRenderer',
          cellRendererParams: {
            callback: arg => this.handleCellClick('editDocument', arg),
          },
        },
        {
          headerName: 'company',
          field: 'company',
          width: 255,
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: exactEqualStringMatcher,
          },
          tooltipComponentParams: { width: 'columnWidth' },
        },
        {
          headerName: 'Last Updated',
          field: 'lastUpdated',
          width: 155,
          minWidth: 155,
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: dateStringMatcher,
          },
          floatingFilterComponent: 'AscAgGridDateFloatFilter',
          floatingFilterComponentParams: {
            suppressFilterButton: true,
            items: this.values,
          },
          valueFormatter: data => getFormattedAPIDate(data.value),
          comparator: this.sortDate,
        },
        {
          field: '',
          width: 120,
          minWidth: 120,
          cellClass: 'preview',
          cellRenderer: 'AscLinkCellRenderer',
          cellRendererParams: {
            value: 'Preview',
            iconClass: 'mdi-chevron-right',
            callback: arg => this.handleCellClick('preview', arg),
          },
        },
      ],
    }
  },

  computed: {},

  methods: {
    handleSelectionGridReady(api) {
      this.$emit('onHelpAboutGridReady', api)
    },
    handleCellClick(cell, params) {
      this.$emit('onGridCellClick', cell, params)
    },
    handleSelectionChanged(selectedRows) {
      this.$emit(
        'onHelpAboutGridSelectionChange',
        selectedRows,
        this.values.length,
      )
    },
  },
}
</script>

<style lang="scss">
.asc-doc-mgmt-help-about-grid {
  margin: 0 16px 33px 16px;

  &--wrapper {
    .asc-grid-wrapper-header--container {
      margin: 0 16px 19px 16px;
    }

    .asc-selection-grid {
      .link-grid-cell {
        cursor: pointer;

        label {
          cursor: pointer;
          color: $accent-700;
        }

        i.v-icon {
          cursor: pointer;
          color: $accent-700;

          &.mdi-pencil {
            display: none;
          }

          &.mdi-chevron-right {
            margin-left: 5.3px;
          }
        }

        &:hover {
          &.document {
            background-color: $accent-0;

            label {
              text-decoration: underline;
            }
          }

          i.v-icon {
            &.mdi-pencil {
              position: absolute;
              margin-left: 5px;
              display: inline;
            }
          }
        }
      }
    }
  }
}
</style>
